export const GET_JOBS_LIST = 'actions/GET_JOBS_LIST';

export const GET_TOP_CATEGORIES = 'actions/GET_TOP_CATEGORIES';

export const GET_JOB_CATEGORIES = 'actions/GET_JOB_CATEGORIES';

export const GET_TOP_CITIES = 'actions/GET_TOP_CITIES';

export const GET_RECENTLY_POSTED = 'actions/GET_RECENTLY_POSTED';

export const GET_TOP_LOCATIONS = 'actions/GET_TOP_LOCATIONS';

export const GET_JOB_DETAILS = 'actions/GET_JOB_DETAILS';

export const GET_JOBS_LIST_FETCH_DONE = 'actions/GET_JOBS_LIST_FETCH_DONE';

export const GET_TOP_CATEGORIES_FETCH_DONE = 'actions/GET_TOP_CATEGORIES_FETCH_DONE';

export const GET_JOB_CATEGORIES_FETCH_DONE = 'actions/GET_JOB_CATEGORIES_FETCH_DONE';

export const GET_TOP_CITIES_FETCH_DONE = 'actions/GET_TOP_CITIES_FETCH_DONE';

export const GET_RECENTLY_POSTED_FETCH_DONE = 'actions/GET_RECENTLY_POSTED_FETCH_DONE';

export const GET_TOP_LOCATIONS_FETCH_DONE = 'actions/GET_TOP_LOCATIONS_FETCH_DONE';

export const GET_JOB_DETAILS_FETCH_DONE = 'actions/GET_JOB_DETAILS_FETCH_DONE';

export const GET_SKILLS_FETCH_DONE = 'actions/GET_SKILLS_FETCH_DONE';

export const GET_SKILLS_FETCH_FAILED = 'actions/GET_SKILLS_FETCH_FAILED';

export const GET_SKILLS = 'actions/GET_SKILLS';

export const SET_CURRENT_JOB = 'actions/SET_CURRENT_JOB';

export const CLEAR_CURRENT_JOB = 'actions/CLEAR_CURRENT_JOB';

export const SET_CURRENT_LOCATION = 'actions/SET_CURRENT_LOCATION';

export const CLEAR_CURRENT_LOCATION = 'actions/CLEAR_CURRENT_LOCATION';

export const SET_CATEGORY = 'actions/SET_CATEGORY';

export const RESET_CATEGORY = 'actions/RESET_CATEGORY';

export const GET_ALL_LOCATIONS = 'actions/GET_ALL_LOCATIONS';

export const GET_ALL_LOCATIONS_DONE = 'actions/GET_ALL_LOCATIONS_DONE';

export const SET_USER_SESSION = 'actions/SET_USER_SESSION';
export const RESET_USER_SESSION = 'actions/RESET_USER_SESSION';
export const SET_USER_PROFILE = 'actions/SET_USER_PROFILE';
export const RESET_USER_PROFILE = 'actions/RESET_USER_PROFILE';

// Search state management
export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';
export const CLEAR_SEARCH_DATA = 'CLEAR_SEARCH_DATA';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_SEARCH_LOADING = 'SET_SEARCH_LOADING';
